import type { Course } from "@booking/booking/api/offer/types";
import type { FailedTeeTimes } from "@booking/booking/api/teeTimes/types";
import {
  BedEnum,
  BookingTypeEnum,
  ImageProviderEnum,
  ImageVariantEnum,
} from "@booking/enums";
import type {
  GolfDetailsDataType,
  HolidaySummaryDataType,
  PackageOverviewDataType,
  PriceDataType,
  RoomsDataType,
  TeeTimesDataType,
} from "@booking/types";
import { DatePlannerDataType } from "@quote/types";
import type { SearchResult } from "@search/api/types";

import { CUSTOMER_SERVICE } from "./consts";

const price = 230.5;

export const datePlannnerData: DatePlannerDataType = [
  { book: true, date: new Date(2023, 7, 19), duration: 2, price },
  { book: true, date: new Date(2023, 7, 20), duration: 2, price },
  { book: true, date: new Date(2023, 9, 5), duration: 2, price },
  { book: true, date: new Date(2023, 9, 6), duration: 2, price },
  { book: true, date: new Date(2023, 7, 15), duration: 2, price },
  { book: true, date: new Date(2023, 7, 29), duration: 2, price },
  { book: true, date: new Date(2023, 7, 16), duration: 2, price },
  { book: true, date: new Date(2023, 7, 17), duration: 2, price },
  { book: true, date: new Date(2023, 7, 21), duration: 2, price },
  { book: false, date: new Date(2023, 7, 26), duration: 2, price },
  { book: false, date: new Date(2023, 7, 22), duration: 2, price },
  { book: true, date: new Date(2023, 7, 23), duration: 1, price },
  { book: true, date: new Date(2023, 7, 25), duration: 2, price },
  { book: true, date: new Date(2023, 8, 4), duration: 2, price },
  { book: false, date: new Date(2023, 8, 5), duration: 1, price },
  { book: true, date: new Date(2023, 8, 6), duration: 2, price },
  { book: false, date: new Date(2023, 8, 7), duration: 2, price },
  { book: true, date: new Date(2023, 8, 8), duration: 2, price },
  { book: false, date: new Date(2023, 7, 27), duration: 2, price },
  { book: true, date: new Date(2023, 7, 28), duration: 1, price },
  { book: false, date: new Date(2023, 9, 4), duration: 2, price },
  { book: true, date: new Date(2023, 9, 7), duration: 2, price },
  { book: true, date: new Date(2024, 0, 3), duration: 3, price },
  { book: true, date: new Date(2024, 0, 4), duration: 1, price },
  { book: true, date: new Date(2024, 2, 8), duration: 3, price },
  { book: true, date: new Date(2024, 2, 9), duration: 2, price },
  { book: true, date: new Date(2024, 2, 10), duration: 1, price },
  { book: true, date: new Date(2024, 0, 5), duration: 3, price },
  { book: true, date: new Date(2024, 0, 12), duration: 2, price },
  { book: true, date: new Date(2024, 0, 13), duration: 2, price },
];

export const failedTeeTimesData: FailedTeeTimes = {
  "The Brabazon": [
    {
      date: "25/05/2023",
      noPlayers: 2,
      time: "10:30",
    },
    {
      date: "25/05/2023",
      noPlayers: 1,
      time: "11:30",
    },
  ],
  "PGA Course": [
    {
      date: "28/05/2023",
      noPlayers: 1,
      time: "08:10",
    },
    {
      date: "29/05/2023",
      noPlayers: 2,
      time: "10:30",
    },
  ],
};

export const golfDetailsData: GolfDetailsDataType = [
  {
    course: "The Brabazon",
    courseId: 8091,
    date: new Date(2023, 4, 25, 11, 10),
    players: 4,
  },
  {
    course: "PGA Course",
    courseId: 8093,
    date: new Date(2023, 4, 25, 11, 30),
    players: 4,
  },
  {
    course: "The Brabazon",
    courseId: 8091,
    date: new Date(2023, 4, 25, 11, 50),
    players: 4,
  },
  {
    course: "The Brabazon",
    courseId: 8091,
    date: new Date(2023, 4, 25, 12, 30),
    players: 4,
  },
  {
    course: "The Brabazon",
    courseId: 8091,
    date: new Date(2023, 4, 26, 12, 10),
    players: 4,
  },
  {
    course: "PGA Course",
    courseId: 8093,
    date: new Date(2023, 4, 26, 11, 30),
    players: 4,
  },
];

export const offerCoursesData: Array<Course> = [
  {
    id: 8920,
    image: {
      alt: "",
      src: "",
    },
    name: "Brabazon Course",
  },
  {
    id: 8921,
    image: {
      alt: "",
      src: "",
    },
    name: "PGA National Course",
  },
  {
    id: 8922,
    image: {
      alt: "",
      src: "",
    },
    name: "Derby Course",
  },
];

export const packageOverviewData: PackageOverviewDataType = {
  boardBasis: "Bed and Breakfast",
  booking: {
    ref: "012345",
    type: BookingTypeEnum.QUOTE,
  },
  date: new Date(2023, 10, 16),
  guidePrice: price,
  image: {
    alt: "The Belfry",
    provider: ImageProviderEnum.CLOUDINARY,
    src: "https://ygt-res.cloudinary.com/image/upload/v1614072441/Venues/The%20Belfry/the-belfry-4.jpg",
    variant: ImageVariantEnum.SUMMARY,
  },
  nights: "2 nights",
  players: 4,
  rounds: "2 rounds",
  venue: "The Belfry",
  eurotunnel: false,
  flights: false,
  airportTransfer: false,
  golfTransfers: false,
};

export const priceData: PriceDataType = {
  deposit: 300,
  discounts: [
    { name: "Early booking discount", amount: -50 },
    { name: "1 in 16 go free", amount: -75 },
  ],
  perPerson: 263,
  total: 1052,
  totalDate: new Date(2024, 2, 1),
  totalSavings: -125,
};

export const packagePriceCounts = [
  [200, 45],
  [400, 24],
  [600, 14],
  [800, 34],
  [1000, 16],
  [1200, 24],
  [1400, 30],
  [1600, 10],
];

export const roomDetailsData: RoomsDataType = {
  rooms: [
    {
      bedType: BedEnum.DOUBLE,
      name: "Signature Room, Golf Package*",
      occupants: 2,
    },
    {
      bedType: BedEnum.TWIN,
      name: "Standard Room, Golf Package",
      occupants: 2,
    },
    {
      bedType: BedEnum.DOUBLE,
      name: "Signature Room, Golf Package",
      occupants: 2,
    },
  ],
};

export const searchResult: SearchResult = {
  accommodation: [
    {
      boardBasis: "Bed & Breakfast",
      hotelName: "Hotel Splendide",
      nights: 3,
    },
    {
      boardBasis: "Half Board",
      hotelName: "Hotel de Ville",
      nights: 2,
    },
  ],
  allocatedRounds: [
    {
      courseName: "America Course",
      rounds: 2,
    },
    {
      courseName: "Oceania Course",
      rounds: 2,
    },
  ],
  bookOnline: false,
  breadcrumb: ["Murcia", "Spain"],
  countryCode: "es",
  fourBall: false,
  image:
    "https://ygt-res.cloudinary.com/image/upload/v1614072441/Venues/The%20Belfry/the-belfry-4.jpg",
  labels: [
    {
      slug: "free-buggies",
      name: "Free buggies",
    },
  ],
  nights: 3,
  numberOfReviews: 100,
  packageId: 4765,
  price: 341,
  reviewRating: 8.0,
  rounds: 2,
  slug: "la-manga-las-lomas-village",
  topPicks: false,
  totalPackageCount: 7,
  tours: false,
  unallocatedRounds: {
    courses: ["Micronesia Course", "Antarctica Course"],
    rounds: 2,
  },
  unlimitedRounds: ["Europa Course", "Asia Course"],
  venueId: 42,
  venueName: "La Manga Las Lomas Village",
  transportation: {
    eurotunnel: false,
    flights: false,
    airportTransfers: false,
    golfTransfers: false,
    flightGolfBagIncluded: false,
  },
  venue: {
    breadcrumbs: ["Murcia", "Spain"],
    countryCode: "es",
    distance: 46,
    id: 42,
    image: packageOverviewData.image,
    name: "La Manga Las Lomas Village",
    totalPackageCount: 7,
    rating: 8.845,
    ratingCount: 73,
    slug: "la-manga-las-lomas-village",
  },
  featured: false,
};

export const teetimesData: TeeTimesDataType = {
  courseOptions: [
    {
      children: "The Brabazon",
      disabled: false,
      image: {
        alt: "The Brabazon",
        provider: ImageProviderEnum.CLOUDINARY,
        src: "https://ygt-res.cloudinary.com/image/upload/v1614072441/Venues/The%20Belfry/the-belfry-4.jpg",
        variant: ImageVariantEnum.NONE,
      },
      name: "teetime-course",
      value: "1",
    },
    {
      children: "The Derby",
      disabled: false,
      image: {
        alt: "The Derby",
        provider: ImageProviderEnum.CLOUDINARY,
        src: "https://ygt-res.cloudinary.com/image/upload/v1614072441/Venues/The%20Belfry/the-belfry-4.jpg",
        variant: ImageVariantEnum.THUMBNAIL,
      },
      name: "teetime-course",
      value: "2",
    },
  ],
  currentRound: 1,
  dateOptions: [
    {
      disabled: false,
      text: "Tuesday 25th April 2023",
      value: "2023-04-25T00:00:00Z",
    },
    {
      disabled: false,
      text: "Wednesday 26th April 2023",
      value: "2023-04-26T00:00:00Z",
    },
    {
      disabled: false,
      text: "Thursday 27th April 2023",
      value: "2023-04-27T00:00:00Z",
    },
    {
      disabled: false,
      text: "Friday 28th April 2023",
      value: "2023-04-28T00:00:00Z",
    },
  ],
  leadGolferFirstName: "Darren",
  leadGolferLastName: "Clarke",
  maxRounds: 2,
  selectedCourse: 1,
  selectedDate: new Date(2023, 4, 26),
  timesData: [
    {
      availablePlayers: 4,
      course: 1,
      id: "0",
      maxPlayers: 4,
      selectedPlayers: 0,
      time: new Date(2023, 4, 25, 10, 10),
      timeslot: "2023-05-25 10:10",
      sourceType: "Brs",
    },
    {
      availablePlayers: 3,
      course: 1,
      id: "1",
      maxPlayers: 3,
      selectedPlayers: 0,
      time: new Date(2023, 4, 25, 10, 20),
      timeslot: "2023-05-25 10:20",
      sourceType: "Brs",
    },
    {
      availablePlayers: 4,
      course: 1,
      id: "2",
      maxPlayers: 4,
      selectedPlayers: 4,
      time: new Date(2023, 4, 25, 11, 10),
      timeslot: "2023-05-25 11:10",
      sourceType: "Brs",
    },
    {
      availablePlayers: 2,
      course: 2,
      id: "3",
      maxPlayers: 2,
      selectedPlayers: 0,
      time: new Date(2023, 4, 25, 11, 30),
      timeslot: "2023-05-25 11:30",
      sourceType: "Brs",
    },
    {
      availablePlayers: 4,
      course: 2,
      id: "4",
      maxPlayers: 4,
      selectedPlayers: 0,
      time: new Date(2023, 4, 25, 11, 50),
      timeslot: "2023-05-25 11:50",
      sourceType: "Brs",
    },
  ],
};

export const holidaySummaryData: HolidaySummaryDataType = {
  accommodation: roomDetailsData,
  agent: {
    email: CUSTOMER_SERVICE.EMAIL,
    firstName: CUSTOMER_SERVICE.FIRSTNAME,
    image: {
      alt: [CUSTOMER_SERVICE.FIRSTNAME, CUSTOMER_SERVICE.LASTNAME].join(" "),
      src: CUSTOMER_SERVICE.IMAGE,
    },
    lastName: CUSTOMER_SERVICE.LASTNAME,
    tel: CUSTOMER_SERVICE.TELEPHONE_LOCAL,
    telHref: CUSTOMER_SERVICE.TELEPHONE_HREF,
  },
  extras: ["Free drink on arrival"],
  golf: golfDetailsData,
  isComplete: false,
  overview: packageOverviewData,
  price: priceData,
};
